import { useQuery } from '@tanstack/react-query'

import { appService } from '../../../services/app'
import type {
  AppSetting,
  AppSettingDefaultValue,
  AppSettingGame,
  AppSettingPush,
} from '../../../types/app-setting'

export const APP_SETTING_QUERY_KEY = ['getAppSetting']

export const APP_SETTING_PUSH_QUERY_KEY = ['getAppSettingPush']

export const APP_SETTING_GAME_QUERY_KEY = ['getAppSettingGame']

export const APP_SETTING_DEFAULT_VALUE_QUERY_KEY = ['getAppSettingDefaultValue']

export const useGetAppSetting = () => {
  const { data: appSetting } = useQuery({
    queryKey: APP_SETTING_QUERY_KEY,
    staleTime: Infinity,
    queryFn: appService.getAppSetting,
  })

  const { data: appSettingPush } = useQuery({
    queryKey: APP_SETTING_PUSH_QUERY_KEY,
    staleTime: Infinity,
    queryFn: appService.getAppSettingPush,
  })

  const { data: appSettingGame } = useQuery({
    queryKey: APP_SETTING_GAME_QUERY_KEY,
    staleTime: Infinity,
    queryFn: appService.getAppSettingGame,
  })

  const { data: appSettingDefaultValue } = useQuery({
    queryKey: APP_SETTING_DEFAULT_VALUE_QUERY_KEY,
    staleTime: Infinity,
    queryFn: appService.getAppSettingDefaultValue,
  })

  return {
    appSetting: {
      ...appSetting?.data,
      ...appSettingPush?.data,
      ...appSettingGame?.data,
      ...appSettingDefaultValue?.data,
    } as AppSetting & AppSettingPush & AppSettingGame & AppSettingDefaultValue,
  }
}
